import { Component, Input, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { CardModule } from 'primeng/card'
import { InputTextModule } from 'primeng/inputtext'
import { TooltipModule } from 'primeng/tooltip'
import { AffairPoolItemWithoutSlots } from '../../../../../interventions/services/interventions.service'
import { AddressCopyPayload } from '../../affair-pool-optimization.types'

@Component({
  selector: 'app-pool-no-slot-affairs',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    InputTextModule,
    TooltipModule,
  ],
  templateUrl: './pool-no-slot-affairs.component.html',
  styleUrl: './pool-no-slot-affairs.component.scss',
})
export class PoolNoSlotAffairsComponent {
  @Input() poolAffairsWithoutSlots: AffairPoolItemWithoutSlots[] = []
  @Input() filteredPoolAffairsWithoutSlots: AffairPoolItemWithoutSlots[] = []
  @Input() poolSearchQuery = ''
  @Input() selectedNoSlotAffairId: number | null = null
  @Input() copiedAddressAffairId: number | null = null

  @Output() poolSearchQueryChange = new EventEmitter<string>()
  @Output() noSlotAffairSelected =
    new EventEmitter<AffairPoolItemWithoutSlots>()
  @Output() addressCopied = new EventEmitter<AddressCopyPayload>()
  /** Demande de suppression d'une affaire vivier manuelle (draft). */
  @Output() manualDeleteRequested =
    new EventEmitter<AffairPoolItemWithoutSlots>()
}
